import React from 'react'

const SvgXp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 6v8h-4v4h-4V6h8zM6 6v3h2V6h4v4h-2v4h2v4H8v-3H6v3H2v-4h2v-4H2V6h4zm13 2h-2v4h2V8z'
    />
  </svg>
)

export default SvgXp
